<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-11-29 11:48:48
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-01 16:20:41
 * @FilePath: \H5\src\views\qQetails.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="pic" v-for="(item, index) in listInfo" :key="index">
      <div class="c-pic">
        <img :src="item" alt="" style="width: 100%; height: 100%;" @click="switch_image(item)">
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";

export default {
  data() {
    return {
      list: [],
      listInfo: []
    };
  },
  created() {
    this.list = this.$route.query.listInfo
    this.listInfo = this.list.op.op.picurl.split(',')
    console.log(this.listInfo);
  },
  methods: {
    switch_image(item) {
      ImagePreview([item]);
    },
  },
}
</script>

<style lang="scss" scoped>
.pic {
  position: relative;
  width: 541px;
  height: 393px;
  
  margin: 42px auto;
  .c-pic {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 494px;
    height: 352px;
    background-color: #fff;
    margin: auto;
  }
}
</style>